import * as Types from '../types-hasura.generated';

import { ClientError } from "graphql-request";
import { SplitsFragment } from '../hasura-fragments.generated';
import { useQuery, useInfiniteQuery, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData } from '@tanstack/react-query';
import { hasuraFetcher } from 'lib/clients/hasura-client';
export type CollectionOwnersSplitsVariables = Types.Exact<{
  contractAddress: Types.Scalars['String'];
}>;


export type CollectionOwnersSplits = { collection: Array<{ splits: Array<(
      Pick<Types.Split_Recipient, 'id' | 'contractAddress' | 'indexOfShare' | 'publicKey' | 'sharePercent'>
      & { user: Pick<Types.User, 'name' | 'profileImageUrl' | 'publicKey' | 'username'> }
    )>, ownersCount: { aggregate: Types.Maybe<Pick<Types.Artwork_Aggregate_Fields, 'count'>> }, ownedArtworks: Array<{ owner: Types.Maybe<Pick<Types.User, 'name' | 'username' | 'publicKey' | 'profileImageUrl'>> }> }> };



export const CollectionOwnersSplitsDocument = /*#__PURE__*/ `
    query CollectionOwnersSplits($contractAddress: String!) {
  collection(where: {contractAddress: {_eq: $contractAddress}}) {
    splits: splitRecipients {
      ...SplitsFragment
    }
    ownersCount: artworks_aggregate(
      where: {deletedAt: {_is_null: true}, hiddenAt: {_is_null: true}, isIndexed: {_eq: true}, tokenId: {_is_null: false}}
      distinct_on: ownerPublicKey
    ) {
      aggregate {
        count
      }
    }
    ownedArtworks: artworks(
      where: {deletedAt: {_is_null: true}, hiddenAt: {_is_null: true}, isIndexed: {_eq: true}, tokenId: {_is_null: false}}
      distinct_on: ownerPublicKey
      limit: 5
    ) {
      owner {
        name
        username
        publicKey
        profileImageUrl
      }
    }
  }
}
    ${SplitsFragment}`;

export const useCollectionOwnersSplits = <
      TData = CollectionOwnersSplits,
      TError = ClientError
    >(
      variables: CollectionOwnersSplitsVariables,
      options?: Omit<UseQueryOptions<CollectionOwnersSplits, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<CollectionOwnersSplits, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<CollectionOwnersSplits, TError, TData>(
      {
    queryKey: ['CollectionOwnersSplits', variables],
    queryFn: hasuraFetcher<CollectionOwnersSplits, CollectionOwnersSplitsVariables>(CollectionOwnersSplitsDocument, variables),
    ...options
  }
    )};

useCollectionOwnersSplits.getKey = (variables: CollectionOwnersSplitsVariables) => ['CollectionOwnersSplits', variables];

export const useInfiniteCollectionOwnersSplits = <
      TData = InfiniteData<CollectionOwnersSplits>,
      TError = ClientError
    >(
      variables: CollectionOwnersSplitsVariables,
      options: Omit<UseInfiniteQueryOptions<CollectionOwnersSplits, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<CollectionOwnersSplits, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<CollectionOwnersSplits, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? ['CollectionOwnersSplits.infinite', variables],
      queryFn: (metaData) => hasuraFetcher<CollectionOwnersSplits, CollectionOwnersSplitsVariables>(CollectionOwnersSplitsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteCollectionOwnersSplits.getKey = (variables: CollectionOwnersSplitsVariables) => ['CollectionOwnersSplits.infinite', variables];


useCollectionOwnersSplits.fetcher = (variables: CollectionOwnersSplitsVariables, options?: RequestInit['headers']) => hasuraFetcher<CollectionOwnersSplits, CollectionOwnersSplitsVariables>(CollectionOwnersSplitsDocument, variables, options);
